if (!window.Eurus.loadedScript.has('sticky-atc.js')) {
  window.Eurus.loadedScript.add('sticky-atc.js');

  document.addEventListener('alpine:init', () => {
    Alpine.data('xStickySmart', (sectionId, initialId) => ({
      // Initiale Sichtbarkeit berechnen (Verhindert FOUC)
      show: window.scrollY > 300,
      
      allVariants: [],
      productOptions: [],
      selectedOptions: {},
      currentVariantId: initialId,
      available: true,
      inventory: 100, 
      loading: false,

      init() {
        try {
            const jsonEl = document.getElementById('sticky-json-' + sectionId);
            const optEl = document.getElementById('sticky-options-' + sectionId);
            if (!jsonEl || !optEl) return;

            this.allVariants = JSON.parse(jsonEl.innerHTML);
            this.productOptions = JSON.parse(optEl.innerHTML);
        } catch(e) {
            console.error('Sticky ATC Error:', e);
            return;
        }

        // Initiale Variante
        const initialVariant = this.allVariants.find(v => v.id == initialId);
        if (initialVariant) this.setVariantState(initialVariant);

        // Event Listener für Variantenwechsel vom Hauptprodukt
        document.addEventListener(`eurus:product-page-variant-select:updated:${sectionId}`, (e) => {
            if (e.detail.variant) this.setVariantState(e.detail.variant);
        });

        // Event Listener für Scroll (manuell als Backup)
        window.addEventListener('scroll', () => { this.handleScroll(); }, { passive: true });
        
        // Check beim Laden
        this.handleScroll();
      },

      handleScroll() {
        // SAFETY LOCK: Wenn gerade geladen wird (Klick erfolgt),
        // zwingen wir die Bar sichtbar zu bleiben. Kein Flackern, kein Verschwinden.
        if (this.loading) {
            this.show = true;
            return;
        }

        // Standard Logik
        this.show = window.scrollY > 300;
      },

      async addToCart() {
        if (this.loading || !this.available) return;
        
        // 1. STATE INSTANT SETZEN (Sofort Feedback)
        this.loading = true;
        this.show = true; // Zwingt die Bar sichtbar zu bleiben

        // Optional: Warten auf Eurus Helper (nur wenn nötig, sonst überspringen)
        try {
            if (Alpine.store('xCartHelper') && Alpine.store('xCartHelper').waitForEstimateUpdate) {
                // Kurzes Timeout, damit die UI nicht blockiert, falls Helper hängt
                const timeoutPromise = new Promise(resolve => setTimeout(resolve, 50)); 
                await Promise.race([Alpine.store('xCartHelper').waitForEstimateUpdate(), timeoutPromise]);
            }
        } catch(e) {}

        const sectionsToRender = Alpine.store('xCartHelper') ? Alpine.store('xCartHelper').getSectionsToRender().map((s) => s.id) : [];
        const payload = { items: [{ id: this.currentVariantId, quantity: 1 }], sections: sectionsToRender };

        // Fetch Request
        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
        })
        .then(response => response.json())
        .then(response => {
            if (response.status === 422) {
                alert(response.description);
                this.loading = false;
                return;
            }

            // Theme spezifische Updates (Warenkorb HTML neu rendern)
            if (Alpine.store('xCartHelper')) {
                Alpine.store('xCartHelper').getSectionsToRender().forEach((section) => {
                    const sectionElement = document.querySelector(section.selector);
                    if (sectionElement && response.sections[section.id]) {
                         const parser = new DOMParser();
                         const doc = parser.parseFromString(response.sections[section.id], 'text/html');
                         sectionElement.innerHTML = doc.querySelector(section.selector)?.innerHTML || response.sections[section.id];
                    }
                });
            }

            // Popups schließen
            if (Alpine.store('xQuickView')) Alpine.store('xQuickView').show = false;
            if (Alpine.store('xPopup')) Alpine.store('xPopup').close();

            // Warenkorb öffnen
            if (Alpine.store('xCartNoti') && Alpine.store('xCartNoti').enable) {
                Alpine.store('xCartNoti').setItem(response.items[0]); 
            } else if (Alpine.store('xMiniCart')) {
                Alpine.store('xMiniCart').openCart();
            }
            
            document.dispatchEvent(new CustomEvent("eurus:cart:items-changed"));
        })
        .catch((error) => {
            console.error(error);
            this.loading = false; 
        })
        .finally(() => {
            // Wir halten den Loading-State noch ganz kurz aktiv für eine smoothe Transition,
            // bis der Drawer sich öffnet.
            setTimeout(() => {
                this.loading = false;
                // Erst jetzt prüfen wir wieder den Scroll-Status
                this.handleScroll();
            }, 600);

            if (Alpine.store('xCartHelper') && Alpine.store('xCartHelper').updateEstimateShippingFull) {
                Alpine.store('xCartHelper').updateEstimateShippingFull();
            }
        });
      },

      selectOption(name, value) {
        this.selectedOptions[name] = value;
        const match = this.allVariants.find(variant => {
            return variant.options.every((val, index) => {
                const optName = this.productOptions[index];
                return this.selectedOptions[optName] === val;
            });
        });

        if (match) {
            this.setVariantState(match);
            if (match.featured_media) {
                 const img = document.getElementById('p-img-' + sectionId);
                 if(img) img.src = match.featured_media.preview_image.src;
            }
        } else {
            this.available = false;
            this.inventory = 0;
        }
      },

      setVariantState(variant) {
        this.currentVariantId = variant.id;
        this.available = variant.available;
        
        // Inventory Check
        if (variant && typeof variant.inventory_quantity !== 'undefined') {
             this.inventory = variant.inventory_management ? variant.inventory_quantity : 100;
        } else {
             this.inventory = 100;
        }

        if(variant.options) {
             variant.options.forEach((val, idx) => {
                 const name = this.productOptions[idx];
                 this.selectedOptions[name] = val;
             });
        }
      }
    }));
  });
}